<template>
  <div class="node-action">
    <slot></slot>
    <span @click="deleteAction" >
      <Trash />
    </span>
  </div>
</template>

<script>
import helpers from '@/helpers'
import Trash from '@/components/icons/Trash'

export default {
  data: () => {
    return {}
  },
  props: ['answer', 'index'],
  computed: {},
  mounted() {},
  methods: {
    deleteAction() {
      this.$emit('deleteAction');
    }
  },
  components: {Trash}
}

</script>

<style lang="scss">
  .node-action {
    padding: 8px 10px;
    margin: 4px 0;
    width: 100%;
    background-color: #2F3B4D;
    border: 1px solid #555555;
    font-size: 13px;
    border-radius: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>